import { loggingConstants } from '../constants';

export function loggingReducers(state = {}, action) {
    switch (action.type) {

        // Get Logs
        
        case loggingConstants.getLogs_request:
            return {
                ...state,
                getLogs_requesting: true, getLogs_status: false,
            }
        case loggingConstants.getLogs_success:
            return {
                ...state,
                getLogs_requesting: false, getLogs_status: true,
                logList: action.details.data,
                logListHeaders: action.details.headers,
            }
        case loggingConstants.getLogs_failure:
            return {
                ...state,
                getLogs_requesting: false, getLogs_status: false, 
            }

        default:
            return state;
    }
}